import { useContext } from "react";

import { ReadOnlyModeContext } from "../context/ReadOnlyModeContextDef";

export const useReadOnlyMode = () => useContext(ReadOnlyModeContext);
